var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingMechanism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.8389,
    r: 21,
    fill: "url(#paint0_linear_278_4254)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2675 11.6432H30.0594C30.071 11.2879 30.0775 10.9304 30.0775 10.5713C30.0775 10.1667 29.7494 9.83887 29.3451 9.83887H13.6549C13.2505 9.83887 12.9225 10.1667 12.9225 10.5713C12.9225 10.9304 12.9289 11.2879 12.9406 11.6432H9.73242C9.32787 11.6432 9 11.9711 9 12.3756C9 15.6574 9.85773 18.7536 11.4151 21.0941C12.9545 23.4079 15.0051 24.735 17.2203 24.8642C17.7225 25.4106 18.2533 25.8562 18.8062 26.1961V29.4513H17.5775C16.0921 29.4513 14.8838 30.6598 14.8838 32.1451V33.3738H14.8317C14.4272 33.3738 14.0993 33.7019 14.0993 34.1062C14.0993 34.5108 14.4272 34.8386 14.8317 34.8386H28.1682C28.5728 34.8386 28.9007 34.5108 28.9007 34.1062C28.9007 33.7019 28.5728 33.3738 28.1682 33.3738H28.1162V32.1451C28.1162 30.6598 26.9079 29.4513 25.4224 29.4513H24.1937V26.1961C24.7467 25.8564 25.2777 25.4106 25.7799 24.8642C27.9949 24.735 30.0455 23.4079 31.5851 21.0941C33.1424 18.7536 34 15.6574 34 12.3756C34 11.9711 33.6721 11.6432 33.2675 11.6432ZM12.6346 20.2827C11.35 18.3523 10.5953 15.8274 10.4803 13.1081H13.0224C13.2866 16.4509 14.0712 19.5408 15.2977 21.9934C15.493 22.384 15.6973 22.7531 15.9092 23.1006C14.6909 22.6406 13.5635 21.6789 12.6346 20.2827ZM26.6513 32.1451V33.374H16.3486V32.1451C16.3486 31.4676 16.8998 30.9162 17.5775 30.9162H25.4224C26.1001 30.9162 26.6513 31.4676 26.6513 32.1451ZM22.7289 29.4513H20.2711V26.8325C20.6737 26.9386 21.084 26.9937 21.5 26.9937C21.916 26.9937 22.3262 26.9386 22.7289 26.8325V29.4513ZM23.1824 25.09C23.1494 25.1035 23.1178 25.1199 23.0875 25.1381C22.5698 25.3956 22.0378 25.5289 21.5 25.5289C20.9623 25.5289 20.4305 25.3956 19.9131 25.1384C19.8824 25.1199 19.8505 25.1035 19.8171 25.0896C19.2428 24.786 18.6872 24.3274 18.1617 23.7249C18.1341 23.6854 18.103 23.649 18.0685 23.6158C17.5468 22.9965 17.0561 22.2347 16.6078 21.3383C15.2618 18.6464 14.4844 15.107 14.3959 11.3037H28.6041C28.5154 15.107 27.7379 18.6466 26.3921 21.3383C25.9439 22.2347 25.4531 22.9965 24.9317 23.6158C24.897 23.649 24.8655 23.6856 24.838 23.7251C24.3125 24.3278 23.7567 24.7862 23.1824 25.09ZM30.3653 20.2827C29.4364 21.6789 28.309 22.6406 27.0908 23.1006C27.3027 22.7531 27.507 22.384 27.7023 21.9934C28.9287 19.5408 29.7132 16.4509 29.9776 13.1081H32.5197C32.4046 15.8274 31.6499 18.3523 30.3653 20.2827Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_278_4254",
    x1: 21,
    y1: 0.838867,
    x2: 21,
    y2: 42.8389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(9 9.83887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingMechanism);
export default __webpack_public_path__ + "static/media/Ranking-Mechanism.fbc27c3ee1e21a4474d3fbb2997e8e76.svg";
export { ForwardRef as ReactComponent };